import { v4 as uuid_v4 } from 'uuid';

const baseUrl: string | undefined = process.env.REACT_APP_API_URL;

const accessBaseUrl = {
  cloudwatch_logs: `${baseUrl}/v1/cloudwatchlogs`,
  usageevent: `${baseUrl}/v1/usage-events`
};

const getHeaders = () => {
  const token = getAuthorizationKeyWithExpiry('token');
  const subscriberCode = getAuthorizationKeyWithExpiry('subscriberCode');
  return {
    'x-transaction-id': uuid_v4(),
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${token}`,
    'x-subscriber-code': subscriberCode,
  }
};

export function deleteAuthorizationKey(keys: any) {
  for (const key of keys) {
    localStorage.removeItem(key);
  }
}

export function setAuthorizationObject(authObj: any) {
  for (const key in authObj) {
    setAuthorizationKeyWithExpiry(key, authObj[key].trim(), 3600000)
  }
}

export function setAuthorizationKeyWithExpiry(key: any, value: any, ttl: any) {
  const now = new Date();
  const item = {
    value: value,
    expiry: now.getTime() + ttl,
  };
  localStorage.setItem(key, JSON.stringify(item));
}

export function getAuthorizationKeyWithExpiry(key: any) {
  const itemStr = localStorage.getItem(key);
  if (!itemStr) {
    return null;
  }
  const item = JSON.parse(itemStr);
  const now = new Date();
  if (now.getTime() > item.expiry) {
    localStorage.removeItem(key);
    return null;
  }
  return item.value;
}


export const fetchUsageEvents = (tranId: any) => {
  const options: any = {
    method: 'GET',
    headers: getHeaders(),
  };
  return fetch(accessBaseUrl.usageevent + "/" + tranId, options);
};


export const fetchCloudWatchLogs = (tranId: any, timestamp: any, logGroup: any) => {
  const options: any = {
    method: 'GET',
    headers: getHeaders(),
  };
  return fetch(accessBaseUrl.cloudwatch_logs + "?logTimestamp=" + timestamp + "&logTransactionId=" + tranId + "&logGroup=" + logGroup, options);
};
